import * as BlackCard from 'root/src/client/v2/common/components/BlackCard/BlackCard'
import { DareCardHeader } from 'root/src/client/web/list/listItemComponents/dare/DareCardHeader'
import { DareCardBody } from 'root/src/client/web/list/listItemComponents/dare/DareCardBody'
import { DareCardSeparator } from 'root/src/client/web/list/listItemComponents/dare/DareCardSeparator'
import { twMerge } from 'tailwind-merge'

export const DareCard = ({ className = '' }) => (
	<BlackCard.Root className={twMerge('dare-card mx-[10px] mb-[20px]', className)}>
		<BlackCard.Header style={{ height: '30%', overflow: 'initial' }}>
			<DareCardHeader />
		</BlackCard.Header>
		<BlackCard.Separator>
			<DareCardSeparator />
		</BlackCard.Separator>
		<BlackCard.Body style={{ height: '100%' }}>
			<DareCardBody />
		</BlackCard.Body>
	</BlackCard.Root>
)
